var exports = {
  "gQ": "x31de4314--086bd7--offer-title",
  "WD": "x31de4314--086bd7--labels",
  "nM": "x31de4314--086bd7--row",
  "qH": "x31de4314--086bd7--inner-row",
  "Wq": "x31de4314--086bd7--description-cell",
  "ix": "x31de4314--086bd7--controls-cell",
  "q9": "x31de4314--086bd7--price",
  "rG": "x31de4314--086bd7--price-row",
  "mr": "x31de4314--086bd7--old-price",
};

module.exports = exports;
